import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Location"] */ "/app/src/app/events/[id]/TimeAndLocation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SightMapMarker"] */ "/app/src/app/sights/SightMapMarker.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/features/components/Categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CompositeHeroImage"] */ "/app/src/features/components/CompositeHeroImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentImage"] */ "/app/src/features/components/ContentImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateBadge"] */ "/app/src/features/components/DateBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkButton"] */ "/app/src/features/components/LinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Map"] */ "/app/src/features/components/Map.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useUiStrings"] */ "/app/src/features/store/uiStrings.ts");
